import template from './manager_subordinate_structure_help.html';
import * as Utils from '../../../lib/savanna_utils.js';

class ManagerSubordinateStructureHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class ManagerSubordinateStructureHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new ManagerSubordinateStructureHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'ManagerSubordinateStructureHelp',
	dialog_class: ManagerSubordinateStructureHelpPage,
	template: template,
	template_filename: 'translation/dialogs/manager_subordinate_structure_help',
	provider: 'ps'
};
